import { render, staticRenderFns } from "./AddTrackingId.vue?vue&type=template&id=f0ce584a&scoped=true&"
import script from "./AddTrackingId.vue?vue&type=script&lang=js&"
export * from "./AddTrackingId.vue?vue&type=script&lang=js&"
import style0 from "./AddTrackingId.vue?vue&type=style&index=0&id=f0ce584a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ce584a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VFlex,VForm,VLayout,VTextField})
